import React from 'react';

export function Select({
  label,
  error,
  helperText,
  options = [],
  placeholder = 'Select an option',
  id,
  required,
  className = '',
  ...props
}) {
  const selectId = id || label?.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className={`space-y-2 ${className}`}>
      {label && (
        <label htmlFor={selectId} className="block text-small text-foreground">
          {label}
          {required && <span className="text-muted ml-1">*</span>}
        </label>
      )}
      <select
        id={selectId}
        required={required}
        className={`
          w-full px-4 py-3 bg-secondary border text-foreground text-body
          focus:outline-none focus:border-foreground
          transition-colors duration-normal appearance-none cursor-pointer
          ${error ? 'border-red-500' : 'border-border'}
        `}
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'%3E%3Cpath d='M3 4.5L6 7.5L9 4.5' stroke='%23666666' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right 16px center',
        }}
        {...props}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {(error || helperText) && (
        <p className={`text-caption ${error ? 'text-red-400' : 'text-muted'}`}>
          {error || helperText}
        </p>
      )}
    </div>
  );
}

export default Select;
